<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="productRequired">Product Required</label>
                    <input
                        type="text"
                        class="form-control"
                        id="productRequired"
                        [(ngModel)]="target.productRequired"
                        name="productRequired"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="productName">Product Name</label>
                    <input type="text" class="form-control" id="productName" [(ngModel)]="target.productName" name="productName" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="areasApplied">Area(s) Applied</label>
                    <input type="text" class="form-control" id="areasApplied" [(ngModel)]="target.areasApplied" name="areasApplied" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="preparationMethod">Preparation Method</label>
                    <input
                        type="text"
                        class="form-control"
                        id="preparationMethod"
                        [(ngModel)]="target.preparationMethod"
                        name="preparationMethod"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="dftRequired">DFT Required</label>
                    <input type="text" class="form-control" id="dftRequired" [(ngModel)]="target.dftRequired" name="dftRequired" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    </div>
</form>
